import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../setup/store/store';
import { EventSession } from '../models/event-session.model';

const eventSessionAdapter = createEntityAdapter<EventSession>();

export const eventSessionSlice = createSlice({
    initialState: eventSessionAdapter.getInitialState(),
    name: 'events',
    reducers: {
        eventSessionSetMany: eventSessionAdapter.setMany,
        eventSessionSetOne: eventSessionAdapter.setOne,
    },
});

export const eventSessionSelectors = eventSessionAdapter.getSelectors<RootState>(
    state => state.eventSessions,
);
